import React from 'react';
import PropTypes from 'prop-types'

class InfoMessage extends React.Component {

	render() {

    const style = {
      width: '100%',
      height: '100%',
      color: '#fff',
      padding: '10px',
      borderRadius: '2px',
      fontSize: '14px',
      backgroundColor: 'rgb(106, 42, 42)'
    };

		return(<div style={style}>{this.props.message}</div>);
	}
}

InfoMessage.propTypes = {
  handleClick: PropTypes.func,
  message: PropTypes.string,
  active: PropTypes.bool
};

export {InfoMessage}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/infoMessage.js